/* eslint no-param-reassign: off */
/* eslint arrow-parens: off */

import Vue from "vue";
import Router from "vue-router";
import Cookies from "vue-cookies";

const Login = () => import("./views/login.vue");
const ChangeEmail = () => import("./views/change_email.vue");
const Forgot = () => import("./views/forgot.vue");
const Reset = () => import("./views/reset.vue");
const ResetAccount = () => import("./views/reset_account.vue");
const Verify = () => import("./views/verify.vue");
const Signup = () => import("./views/signup.vue");
const StaffSignup = () => import("./views/staff_signup.vue");
const AccountSignup = () => import("./views/account_signup.vue");
const AccountInvitation = () => import("./views/account_invitations.vue");
const WelcomeSignup = () => import("./views/welcome_signup.vue");
const WelcomeRegistration = () => import("./views/welcome_registration.vue");
const Resend = () => import("./views/resend.vue");
const TemporalLink = () => import("./views/temporal_link.vue");
const RequestDemo = () => import("./views/request_demo.vue");
const Demo = () => import("./views/demo.vue");

Vue.use(Router);
Vue.use(Cookies);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "login",
      component: Login,
      beforeEnter: (to, from, next) => {
        const isDemo = window.location.host.includes("demo.envone.com");

        const component = isDemo ? Demo : Login;

        next({ component });
      },
      props: (route) => ({ email: route.query.email }),
    },
    {
      path: "/forgot",
      name: "forgot",
      component: Forgot,
    },
    {
      path: "/resend",
      name: "/resend",
      component: Resend,
      props: (route) => ({ token: route.query.token }),
    },
    {
      path: "/reset",
      name: "reset",
      component: Reset,
      props: (route) => ({ token: route.query.token }),
    },
    {
      path: "/reset-account",
      name: "reset_account",
      component: ResetAccount,
      props: (route) => ({ token: route.query.token }),
    },
    {
      path: "/verify",
      name: "verify",
      component: Verify,
      props: (route) => ({ token: route.query.token }),
    },
    {
      path: "/signup",
      name: "signup",
      component: Signup,
      props: (route) => ({ plan: route.query.plan }),
    },
    {
      path: "/change_email",
      name: "change_email",
      component: ChangeEmail,
      props: (route) => ({ token: route.query.token }),
    },
    {
      path: "/staff_signup",
      name: "staff_signup",
      component: StaffSignup,
      props: (route) => ({ token: route.query.token }),
    },
    {
      path: "/account_signup",
      name: "account_signup",
      component: AccountSignup,
      props: (route) => ({ token: route.query.token }),
    },
    {
      path: "/request_demo",
      name: "request_demo",
      component: RequestDemo,
    },
    {
      path: "/demo",
      name: "demo",
      component: Demo,
      props: (route) => ({ token: route.query.token }),
    },
    {
      path: "/welcome/signup",
      name: "welcomeSignup",
      component: WelcomeSignup,
    },
    {
      path: "/welcome/registration",
      name: "welcomeRegistration",
      component: WelcomeRegistration,
    },
    {
      path: "/account_invitation",
      name: "account_invitations",
      component: AccountInvitation,
      props: (route) => ({ token: route.query.token }),
    },
    {
      path: "/temporal-link",
      name: "temporal-link",
      component: TemporalLink,
      props: (route) => ({ token: route.query.token }),
    },
  ],
});

function loadLanguage(lang) {
  return import(/* webpackChunkName: "lang-[request]" */ "../locales/" + lang + ".json").then(
    (msgs) => msgs.default
  );
}

const SUPPORTED_LANGS = ["EN", "ES", "PT"];

async function languageRouteBeforeEach(to, from, next, routerRouter, loadLanguageFn) {
  let lang = Vue.$cookies.get("eo-lang");

  if (!lang) {
    // eslint-disable-next-line prefer-destructuring
    lang = navigator.language.split("-")[0];
  }

  lang = lang.toUpperCase();
  if (!SUPPORTED_LANGS.includes(lang)) lang = "EN";

  loadLanguageFn(lang.toLowerCase()).then((messages) => {
    routerRouter.app.$i18n.messages = messages;
    routerRouter.app.$i18n.locale = lang.toLowerCase();

    next();
  });
}

router.beforeEach((to, from, next) => {
  languageRouteBeforeEach(to, from, next, router, loadLanguage);
});

export default router;
